import { Translations } from '../types/Translations';

export const globals = {
  get locale(): string {
    return window.__LOCALE__;
  },

  get staticsBaseUrl(): string {
    return window.__STATICS_BASE_URL__ || '';
  },

  get enableMonitoring(): boolean {
    return window.__ENABLE_MONITORING__;
  },

  get l10n(): Translations {
    return window.__L10N__;
  },

  get experiments(): { [experimentName: string]: 'true' | 'false' } {
    return window.__EXPERIMENTS__;
  },

  get baseConfig(): {
    currency: string;
    appSessionId: string;
    savedPaymentMethodId: string;
    subscriptionsAmount: number;
  } {
    return window.__BASE_CONFIG__;
  },

  get siteCurrency(): string {
    return window.__BASE_CONFIG__?.currency || window.__SITE_CURRENCY__;
  },

  get startLoadTimestamp(): number {
    return window.__START_LOAD_TIMESTAMP__;
  },

  // TODO: use only base config after GA
  get appSessionId(): string {
    return window.__BASE_CONFIG__?.appSessionId || window.__APP_SESSION_ID__;
  },
  get savedPaymentMethodId(): string {
    return window.__BASE_CONFIG__?.savedPaymentMethodId || window.__SAVED_PAYMENT_METHOD_ID__;
  },
  get subscriptionsAmount(): number {
    return window.__BASE_CONFIG__?.subscriptionsAmount;
  },
};
